import { UserType } from '@luminovo/api-contracts';
import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { PcbHomePage } from '@/areas/pcb/Pcb/PcbHomePage/PcbHomePage';
import { PcbTabRoute } from '@/areas/pcb/Pcb/PcbLayout/PcbTabRoute';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/assemblies/$assemblyId/pcb/')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({
        designItemId: 'optional',
        currentParentAssemblyId: 'optional',
    }),
    // Only the overview sends a customer without the PCB module to the details; the other tabs show the upsell page.
    beforeLoad: ({ context: { session }, params }) => {
        if (session.userType === UserType.Customer && !session.isFeatureFlagEnabled('pcb_module')) {
            throw redirect({
                to: '/projects/$projectId/bom/assembly/$assemblyId/details',
                params: { projectId: params.projectId, assemblyId: params.assemblyId },
                replace: true,
            });
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbTabRoute tab={PcbHomePage} />;
}
